import React, { useEffect, useState } from "react";
import { agencyApi } from "./agencyApi";
import { Lightbox, useThumbBlob } from "./Lightbox";

function Thumb({ item, onOpen }) {
  const { objectUrl } = useThumbBlob(item.url);
  return (
    <button className="ag-bts-thumb" onClick={onOpen} data-testid="agency-bts-thumb" aria-label={item.caption || "View photo"}>
      {objectUrl && <img src={objectUrl} alt={item.caption || ""} />}
    </button>
  );
}

// Behind the Scenes — now its OWN dedicated agency portal tab (Agency Portal Stabilisation
// Wave A, 2026-10 fix pass — was embedded on Overview only, where "render nothing while
// empty" made sense; on a dedicated tab the agency must see SOMETHING, not a blank screen).
// Read-only photo grid + lightbox, server-side filtered to `agency_visible: true` rows only
// (GET /agency/projects/{id}/bts-media — modules/build.py). Staff choose per-photo visibility
// on the existing ProjectBtsGallery.jsx; default is OFF for every new upload.
//
// Cursor fix, item 4 (2026-10): agency sharing is images-only for now — the server already
// rejects/ignores a video being turned agency_visible=True, but any pre-existing video row is
// also filtered out here client-side, defense-in-depth ("the agency grid renders images only").
export function AgencyBtsGallery({ projectId }) {
  const [items, setItems] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    agencyApi.btsMedia(projectId).then((r) => {
      const images = (r.data.items || []).filter((m) => !(m.mime_type || "").startsWith("video/"));
      setItems(images.map((m) => ({ id: m.id, caption: m.caption, url: agencyApi.btsMediaFileUrl(projectId, m.id) })));
    }).catch(() => setItems([]));
  }, [projectId]);

  if (items === null) {
    return (
      <div className="ag-section" data-testid="agency-bts-loading">
        <h3 className="ag-h3" style={{ marginBottom: 16 }}>Behind the Scenes</h3>
        <div className="ag-bts-grid">
          {[0, 1, 2, 3].map((i) => <div key={i} className="ag-bts-thumb ag-bts-thumb-skeleton" data-testid="agency-bts-skeleton-item" />)}
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="ag-section" data-testid="agency-bts-empty-section">
        <h3 className="ag-h3" style={{ marginBottom: 16 }}>Behind the Scenes</h3>
        <div className="ag-empty" data-testid="agency-bts-empty">Nothing shared yet.</div>
      </div>
    );
  }

  return (
    <div className="ag-section" data-testid="agency-bts-section">
      <h3 className="ag-h3" style={{ marginBottom: 16 }}>Behind the Scenes</h3>
      <div className="ag-bts-grid">
        {items.map((item, i) => (
          <Thumb key={item.id} item={item} onOpen={() => setOpenIndex(i)} />
        ))}
      </div>
      {openIndex !== null && (
        <Lightbox items={items} index={openIndex} onClose={() => setOpenIndex(null)} onNavigate={setOpenIndex} />
      )}
    </div>
  );
}
